// Carrossel da página inicial — até 10 fotos
// Proporção: 16:9 landscape
// Deixa o campo 'src' vazio ("") para desactivar esse slot
// O carrossel só aparece se pelo menos 1 foto estiver preenchida

const fotos = [
  { src: "/fotos/Carrossel_01.jpg", alt: "Sala de tratamentos_1" },
  { src: "/fotos/Carrossel_02.jpg", alt: "Sala de tratamentos_2" },
  { src: "/fotos/Carrossel_03.jpg", alt: "Sala de tratamentos_3" },
  { src: "/fotos/Carrossel_04.jpg", alt: "Sala de tratamentos_4" },
  { src: "/fotos/Carrossel_05.jpg", alt: "Sala de tratamentos_3" },
  { src: "/fotos/Carrossel_06.jpg", alt: "Sala de tratamentos_4" }
]

export default fotos.filter(f => f.src.trim() !== "")
